// libs
import { styled } from '@nykaa/ui-components';

// constants
import { HIDE_SCROLLBARS } from 'shared/styles/base';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const OverlaySheet = styled(BaseOverlaySheet)`
  width: 100%;
  top: initial;
  animation-duration: 0.3s;
  overflow: hidden;
  ${({ theme }) => `
    background-color: ${theme.colors.surface};
    border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
    -webkit-border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
  `};
  z-index: 1003;
`;

export const Container = styled.div`
  position: relative;
  height: 100%;
  max-height: 90vh; /* Use 90vh as default */
  top: initial;
  overflow-y: scroll;

  ${({ theme }) => `
    border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
    -webkit-border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
  `};

  ${HIDE_SCROLLBARS}

  /* Fallback to 90vh if 90dvh is not supported */
  @supports (height: 90dvh) {
    max-height: 90dvh;
  }
`;
